import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Faq } from '../../types/content';
import { focusRing } from '../../utils/styles';
interface FaqAccordionProps {
  items: Faq[];
}
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const {
    t
  } = useLanguage();
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);
  return <div className="divide-y divide-mist border-y border-mist" data-id="element-377" data-mp="27f8ykjafdv6x">
      {items.map(faq => {
      const open = openId === faq.id;
      return <div key={faq.id} data-id="element-378" data-mp="22mo5xl399o4z">
            <h3 className="font-sans" data-id="element-379" data-mp="1xpxqmzz9ywkm">
              <button type="button" id={`faq-btn-${faq.id}`} aria-expanded={open} aria-controls={`faq-panel-${faq.id}`} onClick={() => setOpenId(open ? null : faq.id)} className={`flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left text-lg font-semibold text-ink transition-colors duration-150 ease-out hover:text-brand ${focusRing}`} data-id="element-380" data-mp="1xowhj11tkk5j">
                {t(faq.question)}
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-[background-color,transform] duration-200 ease-out ${open ? 'rotate-180 bg-brand text-white' : 'bg-brand-tint text-brand'}`} aria-hidden="true" data-id="element-381" data-mp="16q09hi9l2kqc">
                  <ChevronDownIcon className="h-5 w-5" data-id="element-382" data-mp="nrxf0ny9nvl5" />
                </span>
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-383" data-mp="rsps5sa9ekmp">
              {open && <motion.div id={`faq-panel-${faq.id}`} role="region" aria-labelledby={`faq-btn-${faq.id}`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-384" data-mp="2i5ox8bunvns7">
                  <p className="max-w-3xl pb-6 pr-12 leading-relaxed text-ink-soft" data-id="element-385" data-mp="3m3smfzzepmkk">{t(faq.answer)}</p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}